import {
  FC,
  ReactElement,
  ReactNode,
  useEffect,
} from 'react';

import {
  Box,
  CssBaseline,
} from '@mui/material';

import { useTemplateDirectionContext } from '../hooks';
import Content from '../shared-web/components/Content';
import Header from '../shared-web/components/Header';
import Main from '../shared-web/components/Main';
import SideBar from '../shared-web/components/Sidebar';
import { RootState } from '@redux/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AuthLogout } from '@redux/actionCreators/authActions';
import Footer from '@shared-web/components/Footer';

interface LayoutProps {
  children: ReactNode;
}
const MainLayout: FC<LayoutProps> = ({ children }): ReactElement => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const expiredTime = useSelector((state: RootState) => state.auth.user.vallidTo);
  const currentDateTime = new Date();
  const expireDateTime = new Date(expiredTime);
  const isExpired: Boolean = expireDateTime.getTime() <= currentDateTime.getTime() ? true : false;

  useEffect(() => {
    if (isExpired) {
      dispatch(AuthLogout());
      navigate('/')
    }
  }, [isExpired, navigate, dispatch])

  const { rtl } = useTemplateDirectionContext()
  const flexDirection: string = rtl ? "row-reverse" : "row"
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: { flexDirection },
        maxHeight: "100vh",
        maxWidth: "100vw",
        flexGrow: 1,
      }}
    >
      <CssBaseline />
      <SideBar />
      <Main >
        <Header />
        <Content>
          {children}
        </Content>
        {/* <Footer /> */}
      </Main>
    </Box>
  );
};

export default MainLayout;